import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { QuotesSearchProductAdapter } from './search-products.adapter';
import { ProductSearchPage, SearchConfig } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class QuoteSearchProductService {
  page$ = new BehaviorSubject(0);

  constructor(private searchProduct: QuotesSearchProductAdapter) {}

  get(query: string, searchConfig?: SearchConfig): Observable<ProductSearchPage> {
    return this.searchProduct.get(query, searchConfig);
  }
}
